module.exports = __webpack_public_path__ + "static/media/bus-o-echtzeit~EjFhCTjI.def28691.svg";